import React from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Container from 'components/Container';

import imgLogo from 'src/assets/images/logo.svg';

const Footer = () => {
  console.log('test', t('footer'))
  return (
    <Root id="footer">
      <FooterContainer>
        <Column>
          <Logo src={imgLogo} />
        </Column>
        <Column>
          <h4>{t('footer.getInTouch')}</h4>
          <p>{t('footer.contactCopy')}</p>
          <p>
            <b>
              <a href="mailto:info@ivyonthepark.com">{t('footer.email')}</a>
              <br />
            </b>
            {t('footer.tel')} <a href="tel:604-225-0117">604-225-0117</a>
          </p>
        </Column>
        <Column>
          <h4>{t('footer.presentationCentre')}</h4>
          <h4>{t('footer.address')}</h4>
        </Column>
        <Partners>
          <Partner>
            <p>{t('footer.managedBy')}</p>
            <img
              src={require('src/assets/images/footer/wallfinancial.svg')}
              alt=""
            />
          </Partner>
          <Partner>
            <p>{t('footer.marketedBy')}</p>
            <a
              href="https://rennie.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={require('src/assets/images/footer/rennie.svg')}
                alt=""
              />
            </a>
          </Partner>
        </Partners>
      </FooterContainer>
      <Legal>{t('footer.disclaimer')}</Legal>
    </Root>
  );
};

const Root = styled.footer`
  background: ${({ theme }) => theme.colorBackground};
  color: #fff;
  padding: 100px 0 50px;
  text-align: left;
  & > div {
    h4 {
      font-family: ${({ theme }) => theme.fontMedium};
      font-size: 14px;
      letter-spacing: 0.5px;
      margin-bottom: 5px;
    }
    p {
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 1.25;
      max-width: 200px;
    }
    b {
      font-family: ${({ theme }) => theme.fontMedium};
      font-weight: normal;
    }
  }
  a {
    color: #fff;
  }
  @media (max-width: ${media.md}) {
    text-align: center;
    padding-top: 40px;
    p {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const FooterContainer = styled(Container)`
  display: flex;
  margin-bottom: 60px;
  & > div {
    width: 100%;
  }
  @media (max-width: ${media.md}) {
    display: block;
  }
`;

const Logo = styled.img`
  position: relative;
  top: -15px;
  @media (max-width: ${media.md}) {
    top: 0px;
  }
`;

const Partners = styled.div`
  display: flex;
  @media (max-width: ${media.md}) {
    justify-content: center;
  }
`;

const Partner = styled.div`
  margin-right: 40px;
  p {
    margin-bottom: 15px;
    text-transform: uppercase;
  }
  img {
  }
  @media (max-width: ${media.md}) {
    margin: 0 20px;
  }
`;

const Column = styled.div`
  margin-bottom: 40px;
`;

const Legal = styled.p`
  text-align: center;
  font-family: ${({ theme }) => theme.fontLight};
  font-size: 10px;
  padding: 0 20px;
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js